import * as R from 'ramda';

import getFilters from '../../selectors/getSelectedFilters';
import sportsApi from '../../utils/sportsApi';
import { normalize, schema } from 'normalizr';

import { FILTER_REDESIGN } from '../../constants/config';
import getUseRightsholderAttribution from '../../utils/getUseRightsholderAttribution';

const socialPostList = new schema.Entity('socialPostList', undefined, {
    // idAttribute *functions* must return the ids **value** (not key)
    idAttribute: value => value.id,
});

const getPosts = store => async (state, query) => {
    const userClientId = state.user.selectedUserClientId;

    const clientId = state.user.selectedClientId;
    const client = state.user.clientsById[clientId];
    const hasRedesignedFilters = client.permissions.includes(FILTER_REDESIGN);
    const isFirstPage = !query.page || query.page === 0;
    const useRightsholderAttribution = getUseRightsholderAttribution(
        client,
        clientId,
    );

    const newState = R.evolve(
        {
            clients: {
                [userClientId]: {
                    media: {
                        isLoading: R.T,
                        posts: e => (isFirstPage ? {} : e),
                        postsOrder: f => (isFirstPage ? [] : f),
                    },
                },
            },
        },
        state,
    );

    store.setState(newState);

    const { filters, media } = R.path(
        ['clients', userClientId],
        store.getState(),
    );

    const overrides = media.filtersOverride || {};
    const globFilters = getFilters(filters);
    const mvpScoreGreaterThan = filters.mvpScore;

    const payload = {
        action: 'fetchQuery',
        domainObject: {
            ...query,
            pageSize: 100,
            avgMvpScoreGreaterThan: hasRedesignedFilters
                ? parseFloat(mvpScoreGreaterThan)
                : parseFloat(query.avgMvpScoreGreaterThan),
            includeTextTypeExposures: true,
            includeTextMediaTypes: true,
            groupCarouselPosts: true,
            ...globFilters,
            ...overrides,
            ...(useRightsholderAttribution
                ? { useRightsholderAttribution: true }
                : {}),
        },
    };

    const { posts, totals } = await sportsApi
        .url('/social-posts')
        .json(payload)
        .post()
        .json();

    const changesId = filters.changesId;
    const overridesId = filters.overridesId;

    const normalizedData = normalize(Array.isArray(posts) ? posts : [], [
        socialPostList,
    ]);

    const lastState = store.getState();
    const currentPosts = lastState.clients[userClientId].media.posts || {};
    const currentPostsList =
        lastState.clients[userClientId].media.postsOrder || [];
    const newPostsList = normalizedData.result || [];
    const newPostsResponse = normalizedData.entities.socialPostList
        ? normalizedData.entities.socialPostList
        : {};

    const newPosts = isFirstPage
        ? newPostsResponse
        : R.mergeRight(currentPosts, newPostsResponse);

    if (changesId !== lastState.clients[userClientId].filters.changesId) {
        // Ignore response
        return;
    }

    store.setState(
        R.evolve(
            {
                clients: {
                    [userClientId]: {
                        media: {
                            isLoading: R.F,
                            changesId: R.always(changesId),
                            overridesId: R.always(overridesId),
                            posts: R.always(newPosts),
                            postsOrder: isFirstPage
                                ? R.always([...newPostsList])
                                : R.always([
                                      ...currentPostsList,
                                      ...newPostsList,
                                  ]),
                            hasMore: R.always(newPostsList.length === 100),
                            currentPage: R.always(query.page),
                            totals: isFirstPage
                                ? R.always(totals)
                                : {
                                      impressions: R.add(totals.impressions),
                                      videoViews: R.add(totals.videoViews),
                                      engagements: R.add(totals.engagements),
                                      fullMediaValue: R.add(
                                          totals.fullMediaValue,
                                      ),
                                      sponsorMediaValue: R.add(
                                          totals.sponsorMediaValue,
                                      ),
                                  },
                        },
                    },
                },
            },
            lastState,
        ),
        true,
    );
};

export default getPosts;
